module.exports = require("markdown-it-vue");